"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.httpDebugger = exports.HttpDebugger = void 0;
var HttpDebugger = /** @class */ (function () {
    function HttpDebugger() {
    }
    /*
    Called when http request is started
    */
    HttpDebugger.prototype.debugStartHttpRequest = function () {
    };
    /*
    Called when http request is resolved
    */
    HttpDebugger.prototype.debugResolveHttpRequest = function () {
    };
    /*
    Called when http request errored out
    */
    HttpDebugger.prototype.debugFailedHttpRequest = function () {
    };
    return HttpDebugger;
}());
exports.HttpDebugger = HttpDebugger;
exports.httpDebugger = new HttpDebugger();
//# sourceMappingURL=http.debugger.js.map